module.exports = __webpack_public_path__ + "img/icon_moon.d21f1f6c.png";